module.exports = __webpack_public_path__ + "img/case_12.2ab3dbc6.png";